/**
 * groupParallelTools.ts — 主舞台 Timeline 条目分组（过渡实现）
 *
 * @deprecated Phase 4 由 core/projection GroupedToolUseAccumulator + mountCandidates 替代。
 * 对齐参考：CC GroupedToolUseContent · buildMessageLookups 并行同工具分组语义
 */
import type { SessionNode } from '../../types/nodes';

export type TimelineEntry =
  | { kind: 'node'; nodeId: string }
  | { kind: 'tool_group'; toolName: string; nodeIds: string[] };

export interface BuildTimelineEntriesOptions {
  /** @deprecated 使用 projection grouped_tool_use；保留至 Phase 4 迁移完成 */
  groupParallelTools?: boolean;
  hideStandalonePermissions?: boolean;
}

/** @deprecated 见 core/projection；Phase 4 删除 */
export function buildTimelineEntries(
  rootIds: string[],
  byId: Record<string, SessionNode | undefined>,
  options: BuildTimelineEntriesOptions = {},
): TimelineEntry[] {
  const filtered = options.hideStandalonePermissions
    ? rootIds.filter((id) => byId[id]?.kind !== 'permission')
    : [...rootIds];

  if (!options.groupParallelTools) {
    return filtered.map((nodeId) => ({ kind: 'node', nodeId }));
  }

  const entries: TimelineEntry[] = [];
  let i = 0;

  while (i < filtered.length) {
    const id = filtered[i]!;
    const node = byId[id];

    if (node?.kind !== 'tool_call') {
      entries.push({ kind: 'node', nodeId: id });
      i += 1;
      continue;
    }

    const toolName = node.toolName;
    const groupIds = [id];
    let j = i + 1;

    while (j < filtered.length) {
      const nextId = filtered[j]!;
      const next = byId[nextId];
      if (next?.kind !== 'tool_call' || next.toolName !== toolName) break;
      groupIds.push(nextId);
      j += 1;
    }

    if (groupIds.length >= 2) {
      entries.push({ kind: 'tool_group', toolName, nodeIds: groupIds });
    } else {
      entries.push({ kind: 'node', nodeId: id });
    }

    i = j;
  }

  return entries;
}
